import { action } from 'easy-peasy';
import { IActionSetAvailableClientsByPolygon } from '../types';

const setAvailableClientsByPolygon: IActionSetAvailableClientsByPolygon = action(
  (state, payload) => {
    state.availableClientsByPolygon = payload;
  },
);

export default setAvailableClientsByPolygon;
